//This was copied from DealStatus
const UserStatus = {
  COMPLETE: { data: 'complete', title: 'Complete', subtitle: '' },

  //status for internal/testing use -- for paths that should be unreachable
  UNKNOWN: { data: 'unknown' },
};

export default UserStatus;
